export { default } from './TeamChatSystemMessage';
